import { GeekItem } from '@/models';

export function pascalToKebabCase(input: string): string {
  return camelToKebabCase(pascalToCamelCase(input));
}

export function camelToKebabCase(input: string): string {
  return input.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}

export function pascalToCamelCase(input: string): string {
  return input.charAt(0).toLowerCase() + input.slice(1);
}

export const nameof = <T>(name: Extract<keyof T, string>): string => name;

export const buildGeekFullName = (geek: GeekItem): string =>
  `${geek.firstName}${geek.nick ? ' ' + geek.nick + ' ' : ' '}${geek.lastName}`;

export const buildGeekName = (geek: GeekItem): string =>
  `${geek?.firstName} ${geek?.lastName}`;

// https://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript/2117523#2117523
export const uuidv4 = () => {
  // tslint:disable: no-bitwise
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
};

export const containsAllWords = (phrase: string, searchPhrase: string): boolean => {
  const wordsToSearchFor = searchPhrase.toLocaleLowerCase().split(' ');
  const foundWords = wordsToSearchFor.filter((word) => {
    return phrase.toLocaleLowerCase().includes(word);
  });

  return foundWords.length === wordsToSearchFor.length;
};
